import React, { useEffect, useState, useMemo } from 'react';

import { CardHeader, Card, CardBody, Col, Row, Button } from 'reactstrap';
import { api } from "../../../config";
import { ToastContainer, toast } from 'react-toastify';
import CadastroExpositor from "../Cadastro/index"; // importe corretamente
import ImportExpositoresModal from "../Importacao/index";
import ExportacaoExpositor from "../Exportacao";

import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { fetchComAuth } from '../../../common/api';

const Lista = ({ feiraId, editando, rota }) => {
    const [dadosExpositores, setDadosExpositores] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [modalCadastroOpen, setModalCadastroOpen] = useState(false);
    const [modalImportacaoOpen, setModalImportacaoOpen] = useState(false);
    const [expositorEditandoId, setExpositorEditandoId] = useState(null);

    const fetchExpositores = async () => {
      setIsLoading(true);

        try {
          const response = await fetchComAuth(`${api.API_URL}/feiraExpositor/${feiraId}`, {
            method: 'GET'
          });

          const data = await response.json();
          
          setDadosExpositores(data.data || []);
          
        } catch (error) {
          setIsLoading(false);
          toast.error("Erro ao buscar expositores");
        } finally {
          setIsLoading(false);
        }
      };

      useEffect(() => {
        if (!feiraId || !editando) return;

        

        fetchExpositores();
      }, [feiraId, editando]);

      const columns = useMemo(() => [
          {
            header: "Expositor",
            accessorKey: "nome",
            cell: (cell) => (
              <div className="d-flex align-items-center">
                {cell.row.original.logoUrl && (
                  <div className="flex-shrink-0 me-3">
                    <div className="avatar-sm">
                      <span className="avatar-title rounded">
                        <img 
                          src={cell.row.original.logoUrl} 
                          alt={cell.row.original.nome} 
                          className="img-fluid rounded"
                          style={{maxHeight: '40px'}}
                        />
                      </span>
                    </div>
                  </div>
                )}
                <div>
                  <h6 className="mb-0">{cell.row.original.nome}</h6>
                  {cell.row.original.nome_fantasia && (
                    <small className="text-muted">{cell.row.original.nome_fantasia}</small>
                  )}
                </div>
              </div>
            ),
            size: 250
          },
          {
            header: "Status",
            accessorKey: "status",
            cell: (cell) => {
              const status = cell.row.original;
              if (status.pendente) {
                return <span className="badge text-uppercase bg-info-subtle text-info">Pendente</span>;
              } else if (status.aprovado) {
                return <span className="badge text-uppercase bg-success-subtle text-success">Aprovado</span>;
              } else if (status.aprovado === false) {
                return <span className="badge text-uppercase bg-danger-subtle text-danger">Reprovado</span>;
              } else if (status.ativo) {
                return <span className="badge text-uppercase bg-primary-subtle text-primary">Ativo</span>;
              } else {
                return <span className="badge text-uppercase bg-secondary-subtle text-secondary">Inativo</span>;
              }
            },
            filterFn: (row, id, value) => {
              const status = row.original;
              let statusStr = '';
              
              if (status.pendente) statusStr = 'pendente';
              else if (status.aprovado) statusStr = 'aprovado';
              else if (status.aprovado === false) statusStr = 'reprovado';
              else if (status.ativo) statusStr = 'ativo';
              else statusStr = 'inativo';
              
              return value.includes(statusStr);
            },
            size: 120
          },
          {
            header: "CNPJ",
            accessorKey: "cnpj_codigo_internacional",
            size: 150
          },
          {
            header: "Endereço",
            accessorKey: "endereco_completo",
            cell: (cell) => {
              const { endereco, numero, complemento, bairro, cidade, estado, cep } = cell.row.original;
              return (
                <div>
                  {endereco && `${endereco}${numero ? `, ${numero}` : ''}${complemento ? ` - ${complemento}` : ''}`}
                  {bairro && <div>{bairro}</div>}
                  {cidade && <div>{`${cidade}${estado ? `/${estado}` : ''}${cep ? ` - ${cep}` : ''}`}</div>}
                </div>
              );
            },
            filterFn: (row, id, value) => {
              const { cidade, estado } = row.original;
              const cidadeEstado = `${cidade || ''} ${estado || ''}`.toLowerCase();
              return cidadeEstado.includes(value.toLowerCase());
            },
            size: 250
          },
          {
            header: "Contatos",
            accessorKey: "contatos",
            cell: (cell) => {
              const { telefone, celular, whatsapp, email } = cell.row.original;
              return (
                <div>
                  {telefone && <div>{telefone}</div>}
                  {celular && <div>{celular}</div>}
                  {whatsapp && <div>WhatsApp: {whatsapp}</div>}
                  {email && <div className="text-truncate" style={{maxWidth: '200px'}}>{email}</div>}
                </div>
              );
            },
            size: 200
          },
          {
            header: "Criado em",
            accessorKey: "created_at",
            cell: (cell) => new Date(cell.getValue()).toLocaleDateString("pt-BR"),
            size: 50
          },
          {
            header: "Ações",
            cell: (cell) => (
              <div className="d-flex gap-2">
                <Button
                  size="sm"
                  color="success"
                  onClick={() => {
                    setExpositorEditandoId(cell.row.original.id);
                    setModalCadastroOpen(true);
                  }}
                >
                  Editar
                </Button>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => handleDelete(cell.row.original.id)}
                >
                  Remover
                </Button>
              </div>
            ),
            size: 120
          },
        ], []);

  const statusOptions = [
    { value: 'pendente', label: 'Pendente' },
    { value: 'aprovado', label: 'Aprovado' },
    { value: 'reprovado', label: 'Reprovado' },
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' }
  ];

  const handleDelete = async (id) => {
    try {
      const response = await fetchComAuth(`${api.API_URL}/expositor/${id}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        toast.success("Expositor excluído com sucesso!");
        setDadosExpositores(prev => prev.filter(item => item.id !== id));
      } else {
        toast.error("Erro ao excluir expositor.");
      }
    } catch (error) {
      toast.error("Erro de rede ao excluir.");
    }
  };

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />
     
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-2">
                    <Button
                        className="btn btn-info"
                        onClick={() => setModalImportacaoOpen(true)}
                    >
                        Importar
                    </Button>
                     { rota && (
                      <Button
                        className="btn btn-success"
                        onClick={() => {
                          setExpositorEditandoId(null);
                          setModalCadastroOpen(true);
                        }
                      }
                      >
                        Cadastrar
                      </Button>
                    )}
                  </div>
                </CardHeader>
                <CardBody>
                  <ExportacaoExpositor
                    columns={columns}
                    data={dadosExpositores}
                    isGlobalFilter={true}
                    customPageSize={10}
                    tableclassName="align-middle"
                    theadclassName="table-light text-muted"
                    divClassName="table-responsive table-card mb-1"
                    SearchPlaceholder="Pesquise por nome, cidade, CNPJ..."
                    nomeRelatorio='Relatório de Expositores'
                    statusOptions={statusOptions} // Passe as opçõ
                  />
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
     
     <Modal isOpen={modalCadastroOpen} toggle={() => setModalCadastroOpen(false)} size="xl" backdrop="static">
      <ModalHeader toggle={() => setModalCadastroOpen(false)}>
        {expositorEditandoId ? "Editar Expositor" : "Novo Expositor"}
      </ModalHeader>
      <ModalBody>
        <CadastroExpositor
          id={expositorEditandoId}
          feiraId={feiraId}
          onClose={() => {
            setModalCadastroOpen(false);
            fetchExpositores();
          }}
        />
      </ModalBody>
    </Modal>

<Modal isOpen={modalImportacaoOpen} toggle={() => setModalImportacaoOpen(false)} size="xl" backdrop="static">
  <ModalHeader toggle={() => setModalImportacaoOpen(false)}>Importar Expositores</ModalHeader>
  <ModalBody>
    <ImportExpositoresModal
      onClose={() => {
        setModalImportacaoOpen(false);
        fetchExpositores();
      }}
    />
  </ModalBody>
</Modal>

    </React.Fragment>
  );
};

export default Lista;